import React, { FC } from 'react';
import { GridItemWrapper } from './grid-item.style';

import BREAKPOINTS from '../../../style/breakpoints';
import { GridItemProps } from './grid-item.types';
  
const GridItem: FC<GridItemProps> = ({
  breakpoints = BREAKPOINTS,
  xsHidden = false,
  smHidden = false,
  mdHidden = false,
  lgHidden = false,
  xlHidden = false,
  xs,
  sm,
  md,
  lg,
  xl,
  children,
  horizontalGutter = 0,
  verticalGutter = 0,
  content,
  dataAttr,
  ...props }) => {
  // Display both the children and the content provided via props
  return <GridItemWrapper
    verticalGutter={ verticalGutter }
    horizontalGutter={ horizontalGutter }
    xs={ xs }
    sm={ sm }
    md={ md }
    lg={ lg }
    xl={ xl }
    xsHidden={ xsHidden }
    smHidden={ smHidden }
    mdHidden={ mdHidden }
    lgHidden={ lgHidden }
    xlHidden={ xlHidden }
    breakpoints={ breakpoints }
    { ...dataAttr }
  >
    {children}
    {content}
  </GridItemWrapper>;
};

export default GridItem;
